<template>
	<div class="cell dc-post-grid-no-results">
		<p>{{ text }}</p>
	</div>
</template>

<script>
export default {
	props: {
		text: {
			type: String,
			required: true,
		},
	},
};
</script>
